import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const line: Platform = {
  id: 'line',
  name: 'LINE',
  iconIndex: PlatformRegistry.line.index,
  color: PlatformRegistry.line.color,
  buildUrl: (content: ShareContent): string => {
    const text = [content.title, content.url].filter(Boolean).join(' ');
    return buildShareUrl('https://line.me/R/share', {
      text,
    });
  },
};

